// extracted by mini-css-extract-plugin
export default {"error_message":"Error_error_message__kslIO"};